export const careerFormFields = [
  { type: "text",  name: "accessKey",          label: "Access Key",                          required: true, fullWidth: true },
  { type: "text",  name: "firstName",          label: "First Name",                          required: true },
  { type: "text",  name: "lastName",           label: "Last Name",                           required: true },
  { type: "text",  name: "countryCode",        label: "Country Code (e.g. +1, +91)",         required: true },
  { type: "text",  name: "phone",              label: "Phone Number",                        required: true },
  { type: "email", name: "email",              label: "Email",                               required: true },

  { type: "text",  name: "currentSalary",      label: "Current Salary" },
  { type: "text",  name: "expectedSalary",     label: "Expected Salary" },

  { type: "text",  name: "skills",             label: "Primary Skills (keywords)" },

  { type: "text",  name: "locationPreference", label: "Location Preference" },
  { type: "select",name: "workMode",           label: "Work Mode Preference",  options: ["Onsite", "Remote", "Hybrid"] },

  { type: "date",  name: "joiningDate",        label: "Earliest Joining Date" },

  { type: "file",  name: "resume",             label: "Upload Resume (Optional, max 5MB)", accept: ".pdf,.doc,.docx", fullWidth: true },

  { type: "text",  name: "linkedin",           label: "LinkedIn URL" },
  { type: "text",  name: "github",             label: "GitHub / Portfolio URL" },

  { type: "text",  name: "jobId",              label: "Job ID" },

  // name="referral" → CareerPage.jsx maps data.referral → referral_code for backend
  { type: "text",  name: "referral",           label: "Referral Code",                       required: true },

  { type: "checkbox", name: "consent", label: "I consent to my data being stored and processed.", required: true, fullWidth: true }
];